import * as i0 from '@angular/core';
import * as i1 from './code-snippet.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from './code-snippet.component';
import * as i5 from '../i18n/i18n.module';
export const CodeSnippetModuleNgFactory:i0.NgModuleFactory<i1.CodeSnippetModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_r = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵangular_packages_forms_forms_bd = (<any>(null as any));
var _decl0_16:i3.ɵangular_packages_forms_forms_bf = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i4.CodeSnippet = (<any>(null as any));
var _decl0_33:i2.AsyncPipe = (<any>(null as any));
var _decl0_34:i2.UpperCasePipe = (<any>(null as any));
var _decl0_35:i2.LowerCasePipe = (<any>(null as any));
var _decl0_36:i2.JsonPipe = (<any>(null as any));
var _decl0_37:i2.SlicePipe = (<any>(null as any));
var _decl0_38:i2.DecimalPipe = (<any>(null as any));
var _decl0_39:i2.PercentPipe = (<any>(null as any));
var _decl0_40:i2.TitleCasePipe = (<any>(null as any));
var _decl0_41:i2.CurrencyPipe = (<any>(null as any));
var _decl0_42:i2.DatePipe = (<any>(null as any));
var _decl0_43:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_44:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_45:i2.KeyValuePipe = (<any>(null as any));
var _decl0_46:i2.CommonModule = (<any>(null as any));
var _decl0_47:i3.FormsModule = (<any>(null as any));
var _decl0_48:i5.I18nModule = (<any>(null as any));
var _decl0_49:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_50:i0.ElementRef<any> = (<any>(null as any));
function _View_CodeSnippet_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_CodeSnippet_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_32.display === 'inline');
  currVal_0;
  const currVal_1:any = _any;
  currVal_1;
}
